module.exports = __webpack_public_path__ + "static/img/bg.54a8dca9.png";